export const deriveBaselineFromId = (baselineId: string) => {
  // ! hardcoded baseline names. should come from the backend
  if (baselineId == '1') {
    return 'Baseline-2024'
  }

  return `Baseline-${new Date().getFullYear()}`
}
